import { ButtonAsLink } from '../../components/Button'
import { useCurrentUser } from '../../graphql/hooks'
import { useOnboardingSteps } from './OnboardingPage'
import { OnboardingStep, OnboardingStepName } from '../../graphql/types.gen'

interface NextStepButtonProps {
  currentStep?: OnboardingStep
  nextStepName?: OnboardingStepName
}

function NextStepButton({ nextStepName }: NextStepButtonProps) {
  const currentUser = useCurrentUser()
  const onboardingSteps = useOnboardingSteps()

  return (
    <ButtonAsLink
      to={String(nextStepName)}
      onClick={() => {
        currentUser.refetch()
        onboardingSteps.queryResult?.refetch()
      }}
    >
      Next
    </ButtonAsLink>
  )
}

export default NextStepButton
